import type { StoryType } from "@config";
import moment from "moment";

export const isPageChanged = (story: StoryType | null) => {
  if (!story) return false;
  const published = moment(story.publishedAt).format("YYYY-MM-DDTHH:mm:ss");
  const updated = moment(story.updatedAt).format("YYYY-MM-DDTHH:mm:ss");

  const hasPageChanged = moment(updated).isAfter(published);
  return hasPageChanged;
};
